module.exports = __webpack_public_path__ + "img/logo_white.33917a39.svg";